import {useMutation, useQueryClient} from '@tanstack/react-query';

import {deleteCurrencyEventSchedule} from '../api';
import {QUERY__CURRENCY_EVENT_SCHEDULES} from '../queryKeys';

export const useDeleteCurrencyEventSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (scheduleId: string) => deleteCurrencyEventSchedule(scheduleId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__CURRENCY_EVENT_SCHEDULES],
      });
    },
  });
};
